const state = {
    schoolList: null,
    textSearch: '',
    selectSchool: null,
    openDialogForm: false,
    openDialogDelete: false,
}

export default state;